import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FireTruckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fire_truck"}/>
}
